<template>
    <div class="d-flex full-width justify-space-between flex-wrap">
        <div class="mb-4 overflow-x-auto">
            <div
                v-for="(seatRow, index) in seatMap"
                :key="index"
                class="d-flex flex-nowrap seat-map mb-2"
                style="gap: 6px"
            >
                <div v-for="(seat, ind) in seatRow" :key="`${seat && seat} - ${ind}`">
                    <div v-if="typeof seat === 'string'">
                        <div v-if="getIcon(seat)" class="d-flex align-center justify-center">
                            <v-icon size="large" color="primary" style="height: 20px">
                                {{ getIcon(seat) }}
                            </v-icon>
                        </div>
                        <v-card
                            v-else
                            class="d-flex align-center justify-center text-caption"
                            :class="getColor(seat, false, true)"
                        >
                            {{ seat }}
                        </v-card>
                    </div>
                    <div v-else class="full-width">
                        <div v-if="getIcon(seat?.seatNumber)" class="d-flex align-center justify-center">
                            <v-icon v-if="getIcon(seat?.seatNumber)" size="large" color="primary" style="height: 20px">
                                {{ getIcon(seat?.seatNumber) }}
                            </v-icon>
                        </div>
                        <div v-else>
                            <v-card
                                v-if="!seat?.occupied"
                                class="d-flex align-center justify-center text-caption cursor-pointer"
                                :class="[
                                    getColor(seat?.seatNumber, seat?.occupied, seat?.available),
                                    isBookingMode && 'cursor-pointer',
                                ]"
                                :disabled="disabled"
                                @click="clickSeat(seat, index, ind)"
                            >
                                {{ seat?.seatNumber }}
                            </v-card>
                            <template v-else-if="isBookingMode && seat?.occupied">
                                <v-card
                                    class="d-flex align-center justify-center text-caption cursor-pointer bg-grey-lighten-1"
                                >
                                    {{ seat?.seatNumber }}
                                </v-card>
                            </template>
                            <v-tooltip v-else-if="!isBookingMode" location="top">
                                <template v-slot:activator="{props}">
                                    <v-card
                                        v-bind="props"
                                        class="d-flex align-center justify-center text-caption"
                                        :class="getColor(seat?.seatNumber, seat?.occupied, false)"
                                    >
                                        {{ seat?.seatNumber }}
                                    </v-card>
                                </template>
                                <div>{{ $t('order') }}: {{ seat?.orderId }}</div>
                                <div>{{ $t('name') }}: {{ `${seat?.firstName} ${seat?.lastName}` }}</div>
                            </v-tooltip>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    const props = defineProps<{
        seatMap: any
        isBookingMode?: boolean
        disabled?: boolean
    }>()

    const emit = defineEmits<{
        (e: 'change', seat: any, seatMap: any): void
    }>()

    const seatMap = ref(props.seatMap)

    const clickSeat = (seat, rowIndex, seatIndex) => {
        if (props.isBookingMode) {
            seatMap.value[rowIndex][seatIndex].available = !seatMap.value[rowIndex][seatIndex].available
            emit('change', seat, seatMap.value)
        }
    }

    const getIcon = icon => {
        switch (icon) {
            case 'DRIVER':
                return 'mdi-account-tie-hat-outline'
            case 'DOOR':
                return 'mdi-door-open'
            default:
                return ''
        }
    }
    const getColor = (seatNumber, occupied, available) => {
        if (!seatNumber) return ''
        if (occupied) return 'bg-grey-lighten-1'
        if (!available) return 'bg-orange-lighten-2'
        switch (seatNumber) {
            case 'DRIVER':
            case 'DOOR':
            case 'WC':
            case null:
            case undefined:
                return ''
            default:
                return 'bg-green-lighten-2'
        }
    }
</script>

<style scoped lang="scss">
    @use 'vuetify/settings';
    @use 'sass:map';
    .seat-map > * {
        max-width: 60px;
        min-width: 60px;
        word-break: break-all;
    }
</style>
